import {
  BackgroundImage,
  Box,
  Button,
  Container,
  Flex,
  Text,
  Title,
  useMantineTheme,
  useMatches,
} from "@mantine/core";

const Footer: React.FC = () => {
  const theme = useMantineTheme();

  const leftTextFooter = useMatches({
    base: { display: "none" },
    sm: { width: "calc(50% + 16px)", marginRight: "-16px" },
    xl: {
      width: "calc(50% - (89rem - 100vw) / 2)",
      marginRight: "calc((89rem - 100vw) / 2)",
    },
  });

  const rightTextFooter = useMatches({
    base: { display: "none" },
    sm: { width: "calc(50% + 16px)", marginLeft: "-16px" },
    xl: {
      width: "calc(50% - (89rem - 100vw) / 2)",
      marginLeft: "calc((89rem - 100vw) / 2)",
    },
  });

  return (
    <Box
      style={{
        backgroundColor: theme.colors.gray[9],
      }}
    >
      <Container size={1440} mx="auto">
        <Flex>
          <Box flex={1} py={{ base: 30, sm: 50 }} pr={{ base: 0, sm: 50 }}>
            <Title order={1} c="white" pb={50} fw={500}>
              Meet the Dante Platform
            </Title>
            <Text size="lg" c="white" pb="lg">
              Dante replaces all audio and video connections with a computer
              network, effortlessly sending video or hundreds of channels of
              audio over slender Ethernet cables with perfect digital fidelity.
            </Text>
            <Button
              component="a"
              href="https://www.getdante.com/meet-dante/"
              target="_blank"
              className="w-auto"
              variant="default"
            >
              More details
            </Button>
          </Box>
          <BackgroundImage
            src="/foot-r.jpg"
            style={leftTextFooter}
          ></BackgroundImage>
        </Flex>
        <Flex mt={0}>
          <BackgroundImage
            src="/foot-l.jpg"
            style={rightTextFooter}
          ></BackgroundImage>
          <Box flex={1} py={{ base: 30, sm: 50 }} pl={{ base: 0, sm: 50 }}>
            <Title order={1} c="white" pb={50} fw={500}>
              Solutions for Manufacturers
            </Title>
            <Text size="lg" c="white" pb="lg">
              We offer a variety of products to help you develop networked AV
              products. We have chips and modules, IP Cores and fully developed
              reference designs, depending on your needs.
            </Text>
            <Button
              component="a"
              href="https://www.getdante.com/products/solutions-for-manufacturers/"
              target="_blank"
              className="w-auto"
              variant="default"
            >
              More details
            </Button>
          </Box>
        </Flex>
      </Container>
    </Box>
  );
};

export default Footer;
